/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Test_SentInputs */

const en_settings_test_sent = /** @type {(inputs: Settings_Test_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent — check your notifications.`)
};

const he_settings_test_sent = /** @type {(inputs: Settings_Test_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נשלח — בדוק את ההתראות שלך.`)
};

/**
* | output |
* | --- |
* | "Sent — check your notifications." |
*
* @param {Settings_Test_SentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_test_sent = /** @type {((inputs?: Settings_Test_SentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Test_SentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_test_sent(inputs)
	return he_settings_test_sent(inputs)
});